/* import __COLOCATED_TEMPLATE__ from './inbox-list-sub-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type Router from '@ember/routing/router-service';
import type Session from 'embercom/services/session';

interface Arguments {
  route: string;
  translationKey: string;
}

interface Signature {
  Args: Arguments;
  Element: HTMLAnchorElement;
  Blocks: {
    suffix: [];
  };
}

export default class InboxListSubItem extends Component<Signature> {
  @service declare router: Router;
  @service declare session: Session;

  get isActive(): boolean {
    return this.router.currentRouteName?.startsWith(this.args.route) ?? false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::InboxListSubItem': typeof InboxListSubItem;
    'inbox2/left-nav/inbox-list-sub-item': typeof InboxListSubItem;
  }
}
